import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { styles } from './BOUsersStyles';
import { FaTimes, FaPlus, FaTrash } from 'react-icons/fa';
import { SOFTDATANODEJS } from '../../config';

export default function GestaoAcessos({ perfilId, perfilAtual, tipoAcesso, onClose, onSaved }) {
    // ==========================================
    // ESTADOS PARA "TABLES" (MONGODB)
    // ==========================================
    const [studies, setStudies] = useState(perfilAtual?.group?.studies || []);
    const [colecoes, setColecoes] = useState([]);
    const [vagas, setVagas] = useState([]);
    const [selectedColecao, setSelectedColecao] = useState("");
    const [selectedVaga, setSelectedVaga] = useState("");

    // ==========================================
    // ESTADOS PARA "REPORTS" (MYSQL)
    // ==========================================
    const [reportsAssociados, setReportsAssociados] = useState([]);
    const [reportsNaoAssociados, setReportsNaoAssociados] = useState([]);
    const [selectedReportId, setSelectedReportId] = useState("");
    const [selectedPermissao, setSelectedPermissao] = useState(0);
    // ==========================================
    // ESTADOS PARA MODAL DE AVISO/ERRO
    // ==========================================
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const isTables = tipoAcesso === 'tables';

    // ==========================================
    // FUNÇÕES: GESTÃO DE REPORTS (MYSQL)
    // ==========================================
    const fetchReports = useCallback(async () => {
        try {
            const res = await axios.get(`${SOFTDATANODEJS}/mysql/perfis/${perfilAtual.mysql_id}/estudos`);
            setReportsAssociados(res.data.associados);
            setReportsNaoAssociados(res.data.naoAssociados);
        } catch (err) {
            console.error("ERRO [GestaoAcessos]: Falha ao carregar reports.", err);
            setErrorMessage("Erro ao carregar a lista de Reports (Estudos) associados e não associados. Por favor, contate o serviço técnico da DATA E.");
            setShowErrorModal(true);
        }
    }, [perfilAtual.mysql_id]);
    
    // Ao iniciar o modal, verifica que tipo de dados deve ir buscar
    useEffect(() => {
        if (isTables) {
            axios.get(`${SOFTDATANODEJS}/mongodb/opcoes/study-types`)
                .then(res => setColecoes(res.data))
                .catch(err => {
                    console.error("ERRO [GestaoAcessos]: Falha ao carregar coleções.", err);
                    setErrorMessage("Erro ao carregar as coleções (Tables) do servidor. Por favor, contate o serviço técnico da DATA E.");
                    setShowErrorModal(true);
                });
        } else {
            fetchReports();
        }
    }, [isTables, fetchReports]);

    // Quando seleciona uma coleção nas Tables, vai buscar as Vagas
    useEffect(() => {
        if (isTables && selectedColecao) {
            axios.get(`${SOFTDATANODEJS}/mongodb/opcoes/study-waves/${selectedColecao}`)
                .then(res => setVagas(res.data))
                .catch(err => {
                    setErrorMessage(`Erro ao carregar as vagas para a coleção ${selectedColecao}.`);
                    setShowErrorModal(true);
                });
        } else if (!selectedColecao) {
            setVagas([]);
        }
    }, [selectedColecao, isTables]);

    

    const handleAddReport = async () => {
        if (!selectedReportId) {
            setErrorMessage("Por favor, selecione um Report (Estudo) na lista.");
            return setShowErrorModal(true);
        }
        try {
            await axios.post(`${SOFTDATANODEJS}/mysql/perfis/${perfilAtual.mysql_id}/estudos`, {
                estudoId: selectedReportId,
                permissao: selectedPermissao
            });
            setSelectedReportId(""); // Limpa o dropdown
            fetchReports(); // Recarrega as listas instantaneamente
        } catch (error) {
            setErrorMessage("Falha ao dar acesso ao report.");
            setShowErrorModal(true);
        }
    };

    const handleRemoveReport = async (estudoId) => {
        try {
            await axios.delete(`${SOFTDATANODEJS}/mysql/perfis/${perfilAtual.mysql_id}/estudos/${estudoId}`);
            fetchReports(); // Recarrega as listas instantaneamente
        } catch (error) {
            setErrorMessage("Falha ao remover acesso do report.");
            setShowErrorModal(true);
        }
    };

    // ==========================================
    // FUNÇÕES: GESTÃO DE TABLES (MONGODB)
    // ==========================================
    const handleAddAcessoTables = () => {
        if (!selectedColecao || !selectedVaga) {
            setErrorMessage("Por favor, selecione o Estudo e a Vaga antes de adicionar.");
            return setShowErrorModal(true);
        }
        const jaExiste = studies.find(s => s.studyTypes === selectedColecao && s.studyWaves === selectedVaga);
        if (jaExiste) {
            setErrorMessage("O utilizador já tem acesso a esta vaga específica!");
            return setShowErrorModal(true);
        }

        setStudies([...studies, { studyTypes: selectedColecao, studyWaves: selectedVaga }]);
    };

    const handleRemoveAcessoTables = (index) => {
        setStudies(studies.filter((_, i) => i !== index));
    };

    const handleGuardarTables = async () => {
        try {
            await axios.put(`${SOFTDATANODEJS}/mongodb/perfis/${perfilId}/acessos`, { studies });
            if (onSaved) onSaved();
        } catch (error) {
            setErrorMessage("Falha ao gravar os acessos no servidor.");
            setShowErrorModal(true);
        }
    };

    // ==========================================
    // INTERFACE DO MODAL
    // ==========================================
    return (
        <div style={styles.modalOverlay}>
            <div style={{ ...styles.modalContentLarge, maxWidth: '800px', height: 'auto', maxHeight: '90vh' }}>
                
                {/* HEADER DO MODAL (Muda de cor dependendo se é Report ou Tables) */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: `2px solid ${isTables ? '#E67E22' : '#17a2b8'}`, paddingBottom: '10px', marginBottom: '15px' }}>
                    <h2 style={{ margin: 0, color: '#333', fontSize: '18px' }}>
                        <span style={{ color: isTables ? '#E67E22' : '#17a2b8', fontWeight: 'bold' }}>
                            {isTables ? 'Acessos Tables: ' : 'Acessos Report: '} 
                        </span> 
                        {perfilAtual?.nome || perfilAtual?.name}
                    </h2>
                    <button style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }} onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <div style={styles.modalScroll}>
                    
                    {/* ZONA DE ADICIONAR ACESSO */}
                    <div style={{ backgroundColor: '#f9f9f9', padding: '15px', borderRadius: '4px', border: '1px solid #ddd', marginBottom: '20px' }}>
                        <h4 style={{ marginTop: 0, color: '#005c75', fontSize: '14px' }}>Dar Novo Acesso</h4>
                        
                        {isTables ? (
                            // --- DROPDOWNS PARA TABLES ---
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <select style={styles.modalInput} value={selectedColecao} onChange={e => { setSelectedColecao(e.target.value); setSelectedVaga(""); }}>
                                    <option value="">-- Escolha a Coleção (Tabela) --</option>
                                    {colecoes.map(col => <option key={col} value={col}>{col}</option>)}
                                </select>

                                <select style={styles.modalInput} value={selectedVaga} onChange={e => setSelectedVaga(e.target.value)} disabled={!selectedColecao || vagas.length === 0}>
                                    <option value="">-- Escolha a Vaga --</option>
                                    {vagas.map(vaga => <option key={vaga} value={vaga}>{vaga}</option>)}
                                </select>

                                <button onClick={handleAddAcessoTables} style={{ ...styles.footerBtn, background: '#005c75', color: 'white', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                    <FaPlus /> Adicionar
                                </button>
                            </div>
                        ) : (
                            // --- DROPDOWNS PARA REPORTS ---
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <select style={{...styles.modalInput, flex: 2}} value={selectedReportId} onChange={e => setSelectedReportId(e.target.value)}>
                                    <option value="">-- Escolha o Report (Estudo) --</option>
                                    {reportsNaoAssociados.map(rep => <option key={rep.id} value={rep.id}>{rep.nome} ({rep.abr})</option>)}
                                </select>

                                <select style={{...styles.modalInput, flex: 1}} value={selectedPermissao} onChange={e => setSelectedPermissao(Number(e.target.value))}>
                                    <option value={0}>Consulta</option>
                                    <option value={1}>Avançado / Edição</option>
                                </select>

                                <button onClick={handleAddReport} disabled={!selectedReportId} style={{ ...styles.footerBtn, background: '#17a2b8', color: 'white', display: 'flex', alignItems: 'center', gap: '5px', opacity: !selectedReportId ? 0.5 : 1 }}>
                                    <FaPlus /> Adicionar
                                </button>
                            </div>
                        )}
                    </div>

                    {/* TABELA DE ACESSOS ATUAIS */}
                    <table style={styles.table}>
                        <thead style={styles.theadSticky}>
                            {isTables ? (
                                <tr style={styles.theadRow}>
                                    <th style={{ ...styles.th, textAlign: 'left' }}>Coleção (Estudo)</th>
                                    <th style={{ ...styles.th, textAlign: 'left' }}>Vaga (StudyWave)</th>
                                    <th style={{ ...styles.th, width: '80px' }}>Remover</th>
                                </tr>
                            ) : (
                                <tr style={styles.theadRow}>
                                    <th style={{ ...styles.th, textAlign: 'left', width: '60px' }}>ID</th>
                                    <th style={{ ...styles.th, textAlign: 'left' }}>Report (Nome)</th>
                                    <th style={{ ...styles.th, width: '120px' }}>Permissão</th>
                                    <th style={{ ...styles.th, width: '80px' }}>Remover</th>
                                </tr>
                            )}
                        </thead>
                        <tbody>
                            {isTables ? (
                                // --- LINHAS DA TABELA (TABLES) ---
                                studies.length === 0 ? (
                                    <tr><td colSpan="3" style={{ padding: '20px', textAlign: 'center', color: '#666' }}>Nenhum acesso configurado para as Tables.</td></tr>
                                ) : (
                                    studies.map((acesso, index) => (
                                        <tr key={index} style={styles.dataRow}>
                                            <td style={{ ...styles.td, textAlign: 'left', fontWeight: 'bold' }}>{acesso.studyTypes}</td>
                                            <td style={{ ...styles.td, textAlign: 'left' }}>{acesso.studyWaves}</td>
                                            <td style={styles.tdActions}>
                                                <button style={{ ...styles.iconBtn, color: '#dc3545' }} onClick={() => handleRemoveAcessoTables(index)} title="Remover Acesso">
                                                    <FaTrash />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )
                            ) : (
                                // --- LINHAS DA TABELA (REPORTS) ---
                                reportsAssociados.length === 0 ? (
                                    <tr><td colSpan="4" style={{ padding: '20px', textAlign: 'center', color: '#666' }}>Nenhum acesso configurado aos Reports.</td></tr>
                                ) : (
                                    reportsAssociados.map(rep => (
                                        <tr key={rep.id} style={styles.dataRow}>
                                            <td style={{ ...styles.td, textAlign: 'left' }}>{rep.id}</td>
                                            <td style={{ ...styles.td, textAlign: 'left', fontWeight: 'bold' }}>{rep.nome} <span style={{fontSize: '10px', color: '#888'}}>({rep.abr})</span></td>
                                            <td style={styles.td}>{rep.permissao === 0 ? 'Consulta' : 'Edição'}</td>
                                            <td style={styles.tdActions}>
                                                <button style={{ ...styles.iconBtn, color: '#dc3545' }} onClick={() => handleRemoveReport(rep.id)} title="Remover Acesso ao Report">
                                                    <FaTrash />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )
                            )}
                        </tbody>
                    </table>
                </div>

                {/* FOOTER DO MODAL */}
                <div style={styles.modalFooter}>
                    {isTables ? (
                        <button style={{ ...styles.footerBtn, background: '#28a745', color: 'white' }} onClick={handleGuardarTables}>Guardar Alterações</button>
                    ) : (
                        <button style={{ ...styles.footerBtn, background: '#17a2b8', color: 'white' }} onClick={() => { if(onSaved) onSaved(); }}>Concluir</button>
                    )}
                    <button style={styles.footerBtn} onClick={onClose}>Cancelar</button>
                </div>

            </div>
            {/* --- MODAL DE AVISO / ERRO --- */}
            {showErrorModal && (
                <div style={{ ...styles.modalOverlay, zIndex: 3000 }}>
                    <div style={{ ...styles.modalContent, maxWidth: '400px', textAlign: 'center' }}>
                        <div style={{ color: '#E67E22', fontSize: '16px', padding: '15px' }}>
                            <p style={{ fontSize: '40px', margin: '0 0 10px 0' }}>⚠️</p>
                            <strong style={{ color: '#333' }}>Atenção</strong>
                            <p style={{ color: '#333', marginTop: '10px', fontSize: '14px' }}>{errorMessage}</p>
                        </div>
                        <div style={styles.modalFooterCenter}>
                            <button 
                                style={{ ...styles.footerBtn, background: '#E67E22', color: 'white', border: 'none' }} 
                                onClick={() => setShowErrorModal(false)}
                            >
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}